import { render, staticRenderFns } from "./InpatientReview.vue?vue&type=template&id=ad409a4a&scoped=true&"
import script from "./InpatientReview.vue?vue&type=script&lang=js&"
export * from "./InpatientReview.vue?vue&type=script&lang=js&"
import style0 from "./InpatientReview.vue?vue&type=style&index=0&id=ad409a4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad409a4a",
  null
  
)

export default component.exports